import angular, { IPromise } from "angular";
import { IQueryResponse } from "../../../../records/server/query";
import { SubFilter } from "../../../../records/grids/columns/filters/subFilters/subFilters";
import {
  LookupManagementConfig,
  LookupManagementService,
} from "../../../../records/lookup/lookupManagement";
import { GridFilter } from "../../../../records/grids/columns/filters/gridFilter";
import { ServerUtility } from "../../../../records/server/serverUtility";
import { vsObjectName as contractNumberTypeName } from "../../configs/contractNumberType";
import { LookupRecord } from "../../../../records/server/crud";
export class ContractNumberTypeFilter extends SubFilter {
  private readonly contractTypeNumberConfig: LookupManagementConfig;
  private allOptions: LookupRecord[] = [];
  private currentOptions: LookupRecord[] = [];
  constructor(
    contractLookupManagementService: LookupManagementService,
    private readonly serverUtility: ServerUtility
  ) {
    super({
      displayName: "By Type",
      queryFieldNames: [], //filter assumes the query fields being targeted and these are not used
    });

    this.contractTypeNumberConfig =
      contractLookupManagementService.getLookupConfig(contractNumberTypeName);
  }

  private contractNumberTypeQuery(search: string) {
    const normalizedSearch = search.trim().toLowerCase();
    this.currentOptions = this.allOptions.filter((o) =>
      (<any>o.normalized).includes(normalizedSearch)
    );
  }

  init(params: { gridFilter: GridFilter }): void {
    super.init(params);
    this.serverUtility
      .fetchAll<LookupRecord>({
        url: this.contractTypeNumberConfig.baseUrl,
        query: {
          OrderBy: "Name",
        },
      })
      .then((results) => {
        this.allOptions = results;

        results.forEach((r) => {
          r.normalized = r.Name.toLowerCase();
        });
      });
  }

  x = `<div class="form-group">
          <label class="control-label">Title: </label>
          <div class="form-control-static">
            {{stateController.contactBookDetail.Title}}
          </div>
        </div>`;

  getGui(): angular.IAugmentedJQuery {
    return angular.element(`
    <div class="form-group">
      <label class="control-label">Number Type</label>
      <ui-select ng-model="recordGridController.currentQuery.ContractNumberTypeId">
        <ui-select-match allow-clear="true">{{$select.selected.Name}}</ui-select-match>
        <ui-select-choices repeat="option.Id as option in subFilterController.currentOptions"
          refresh="subFilterController.contractNumberTypeQuery($select.search)"
          refresh-delay="500">
          <div>
              {{option.Name}}
          </div>
        </ui-select-choices>
      </ui-select>
    </div>
    <div class="form-group">
      <label class="control-label">Number</label>
      <input ng-model="recordGridController.currentQuery.ContractNumberNumberContains" ng-model-options="gridFilterController.defaultModelOptions" class="form-control" />
    </div>
`);
  }
}

export type ServerQuery<T> = (search: string) => IPromise<IQueryResponse<T>>;

export class LookupFilter extends SubFilter {
  private readonly valueField: string;
  private readonly displayField: string;
  private currentOptions: unknown[] = [];
  private readonly serverQuery: ServerQuery<unknown>;

  constructor(config: {
    displayName: string;
    queryFieldNames: string[];
    valueField?: string;
    displayField?: string;
    serverQuery: ServerQuery<unknown>;
  }) {
    super(config);

    this.serverQuery = config.serverQuery;
    this.valueField = config.valueField || "Id";
    this.displayField = config.displayField || "Name";
  }

  query(search: string) {
    this.serverQuery(search).then((result) => {
      this.currentOptions = result.Results;
    });

    // this.recordServer.executeOperation<any>(this.sourceOperation, {
    //   recordDefinition: this.sourceOperation.recordDefinition,
    //   requestModel: query
    // })
    //   .then(queryResponse => {
    //     const results = queryResponse.Results
    //     this.currentOptions = results
    //   })
  }

  getGui(): angular.IAugmentedJQuery {
    return angular.element(`
    <ui-select ng-model="${this.getQueryFieldExpression()}">
    <ui-select-match allow-clear="true">{{$select.selected[subFilterController.displayField]}}</ui-select-match>
    <ui-select-choices repeat="option[subFilterController.valueField] as option in subFilterController.currentOptions"
      refresh="subFilterController.query($select.search)"
      refresh-delay="500">
      <div>
          {{option[subFilterController.displayField]}}
      </div>
    </ui-select-choices>
  </ui-select>
    `);
  }
}
